import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PosSessionTable from '@pos/components/tables/pos-session-table/pos-session-table.vue';

@Component({
  name: 'bpc-pos-sessions',
  components: {
    'bpc-pos-session-table': PosSessionTable,
  },
})
export default class PosSessions extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
